import React, { useContext } from 'react';
import { useAmplitude } from 'react-amplitude-hooks';
import { KYC_PROVIDER } from 'Enums/KycProvider';
import { USER_STATUS } from 'Enums';
import { ROUTES } from 'Router/Routes';
import { Arrow } from 'Components/shared/symbols';
import { Button } from 'Components/shared/buttons';
import { AuthContext } from 'States/auth/authState';
import { ConfigContext } from 'States/config/configState';
import useKycTierCheck from 'Hooks/useKycTierCheck';
import { i18nextKeys } from 'Lang/i18nextKeys';
import i18nextTranslate from 'Lang/i18nextTranslate';

const AssetCardButtonGroup = ({
  openAssetInfo,
  openAssetModal,
  kycTier
}) => {
  const { logEvent } = useAmplitude();
  const { isUserTierSufficient } = useKycTierCheck(kycTier);
  const {
    isAuthenticated,
    isEmailConfirmed,
    status
  } = useContext(AuthContext);
  const {
    config: { kycTiersDescription }
  } = useContext(ConfigContext);
  const primaryButtonDisabled = isAuthenticated && (
    !isEmailConfirmed || status !== USER_STATUS.Approved
  );
  const buttonTextStyle = {
    fontSize: "16px",
    textTransform: "none"
  };
  const buttonStyle = {
    borderRadius: "8px",
  };
  const buttonHeight = "48px";

  const onClick = () => {
    if (isUserTierSufficient) {
      openAssetModal();
      return;
    }
    logEvent("KYC started", {
      origin: "asset tile",
      provider: kycTiersDescription[1]?.providers[0].name !== KYC_PROVIDER.manual
    });
    window.open(ROUTES.kyc, '_blank');
  };

  return (
    <div
      className="grid md:px-16 gap-12"
      style={{
        gridArea: 'buttons',
        gridTemplateColumns: '1fr',
        height: "min-content",
        gap: "10px",
        paddingLeft: "16px",
        paddingRight: "16px"
      }}
    >
      <Button
        dataQa="assetCard-button-primary"
        onClick={onClick}
        icon={isUserTierSufficient ? null : Arrow}
        text={i18nextTranslate(
          isUserTierSufficient ? i18nextKeys.buttonAddToCart : i18nextKeys.kycGetTierToBuy,
          { tier: kycTier }
        )}
        height={buttonHeight}
        textStyle={buttonTextStyle}
        style={buttonStyle}
        disabled={primaryButtonDisabled}
        secondary={!isUserTierSufficient}
        fullWidth
      />
      <Button
        dataQa="assetCard-button-secondary"
        onClick={openAssetInfo}
        text={i18nextTranslate(i18nextKeys.buttonMoreDetails)}
        className="justify-self-end"
        height={buttonHeight}
        textStyle={buttonTextStyle}
        style={buttonStyle}
        fullWidth
        outlined
      />
    </div>
  );
};

export default AssetCardButtonGroup;
